import { collection, addDoc, query, getDocs, where } from "firebase/firestore";
import { db } from "../../../firebase";

import { placeOrder } from "../../../rtk/slices/orderSlice/orderSlice";
import { placePendingOrder } from "../../../rtk/slices/pendingOrderSlice/pendingOrderSlice";
import { apiKey } from "../../../utils/config";



export const saveVolume = (newVolume, setVolume) => {
    localStorage.setItem('tradingVolume', newVolume);
    setVolume(newVolume);
};

// Helper to generate random 8-digit number
const generateRandom8Digit = () => {
    return Math.floor(10000000 + Math.random() * 90000000).toString();
};

// Ensure uniqueness in Firestore
// const generateUniquePositionId = async () => {
//   let unique = false;
//   let positionId;

//   while (!unique) {
//     positionId = generateRandom8Digit();
//     const q = query(collection(db, "trade_collection"), where("position_id", "==", positionId));
//     const querySnapshot = await getDocs(q);
//     if (querySnapshot.empty) {
//       unique = true;
//     }
//   }

//   return positionId;
// };

export const handleOrder = async (type, selectedSymbol, selectedSymbolBid, volume,sl,tp, dispatch, orderData, orderError) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const account = user.account

    if (selectedSymbol && volume) {
        const position_id = generateRandom8Digit();
        const orderPayload = {
            position_id: position_id,
            account: account,
            symbol: selectedSymbol,
            volume: volume,
            price: selectedSymbolBid,
            current_price:0,
            type: type,
            tp:isNaN(tp) ? 0 : tp,
            sl: isNaN(sl) ? 0 : sl,
            comment: "",
            status:"active",
            timestamp: new Date().toISOString(),
        };

        try {
            const collectionRef = await addDoc(collection(db, "trades_collection"), orderPayload);
            console.log("Order saved to Firestore with ID:", collectionRef.id);
        } catch (error) {
            console.error("Error adding document to Firestore:", error);
        }

        // console.log("Order Payload:", orderPayload);
    }
};

export const hedgeTrade = (position, dispatch, orderData, orderError) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const account = user.account
    if (position) {
        const reversedType = position.type === "SELL" ? "BUY" : "SELL"
        const orderPayload = {
            api_key: apiKey, account: account, symbol: position.symbol, volume: position.volume,
            price: "0", type: reversedType, tp: "0", sl: "0", comment: ""
        };

        dispatch(placeOrder(orderPayload)).then((response) => {
            if (response.meta.requestStatus === 'fulfilled') {
                console.log("Order API response:", orderData);
                // saveVolume(volume);
            } else if (response.meta.requestStatus === 'rejected') {
                console.error("Order API error:", orderError);
            }
        });
    }
};

export const handleLimitOrder = (type, selectedSymbol, volume, trigger, selectedSymbolAsk, selectedSymbolBid, dispatch, orderData, orderError) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const account = user.account
    if (selectedSymbol && volume && trigger) {
        const isValidTrigger =
            (type === 3 && parseFloat(trigger) > parseFloat(selectedSymbolAsk)) ||
            (type === 2 && parseFloat(trigger) < parseFloat(selectedSymbolBid));
        const orderType = type === 2 ? 'BUY' : (type === 3 ? 'SELL' : '');
        if (!isValidTrigger) {
            console.error('Invalid  price!');
            return alert(
                `For a Pending ${orderType} order, the Price must be ${orderType === 'SELL' ? 'less' : 'greater'} than the current ${orderType === 'SELL' ? 'bid' : 'ask'} price.`
            );
            // return alert('For a Pending Sell order, the Price must be less than the current bid price.')
        }
        const orderPayload = {
            api_key: apiKey, account: account, symbol: selectedSymbol, volume: volume, price: "0", type: type,
            tp: "0", sl: "0", comment: "", price_trigger: trigger,
        };

        dispatch(placePendingOrder(orderPayload)).then((response) => {
            if (response.meta.requestStatus === 'fulfilled') {
                console.log("Order API response:", orderData);
            } else if (response.meta.requestStatus === 'rejected') {
                console.error("Order API error:", orderError);
            }
        });
    } else {
        console.error("Missing required fields for limit order.");
        alert("Please fill in all required fields.");
    }
};


export const handleStopOrder = (
    type, selectedSymbol, volume, buyAbove, selectedSymbolAsk, selectedSymbolBid, dispatch,
    orderData, orderError
) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const account = user.account
    if (selectedSymbol && volume && buyAbove) {
        const isValidTrigger =
            (type === 3 && parseFloat(buyAbove) < parseFloat(selectedSymbolAsk)) ||
            (type === 2 && parseFloat(buyAbove) > parseFloat(selectedSymbolBid));

        if (!isValidTrigger) {
            console.error('Invalid trigger price!');
            return alert(
                `For a ${type} order, the trigger price must be ${type === 'SELL' ? 'less than the current ask price' : 'greater than the current bid price'
                }.`
            );
        }

        const orderPayload = {
            api_key: apiKey, account: account, symbol: selectedSymbol, volume: volume, price: "0", type: type,
            tp: "0", sl: "0", comment: "", price_trigger: buyAbove,
        };

        dispatch(placePendingOrder(orderPayload)).then((response) => {
            if (response.meta.requestStatus === 'fulfilled') {
                console.log("Order API response:", orderData);
            } else if (response.meta.requestStatus === 'rejected') {
                console.error("Order API error:", orderError);
            }
        });
    } else {
        console.error("Missing required fields for limit order.");
        alert("Please fill in all required fields.");
    }
};